import { endOfDay, format, isValid, parseISO, startOfDay } from "date-fns";

import { ISO8601_DATE_FORMAT } from "@constants";

import { buildFilterCondition } from "../../../../shared/utils/build-filter-condition";
import { buildFilterExpression } from "../../../../shared/utils/build-filter-expression";
import type {
  ITechWorksFilter,
  ITechWorksPanelFilter,
  ITechWorksPeriod,
} from "../interfaces/tech-works-filter";

export const createEmptyTechWorksPanelFilter = (): ITechWorksPanelFilter => ({
  farmLandId: "",
  techAssetName: "",
  trailerAssetName: "",
  driverFullName: "",
  areaFrom: null,
  areaTo: null,
});

export function getTechWorksFilterCount(filter: ITechWorksPanelFilter): number {
  return (
    Number(Boolean(filter.farmLandId)) +
    Number(Boolean(filter.techAssetName)) +
    Number(Boolean(filter.trailerAssetName)) +
    Number(Boolean(filter.driverFullName)) +
    Number(filter.areaFrom !== null || filter.areaTo !== null)
  );
}

export function getTechWorksPeriod(
  from: Date | null,
  to: Date | null
): ITechWorksPeriod | null {
  if (!from || !to || !isValid(from) || !isValid(to) || startOfDay(from) > endOfDay(to)) {
    return null;
  }

  return {
    from: format(startOfDay(from), ISO8601_DATE_FORMAT),
    to: format(endOfDay(to), ISO8601_DATE_FORMAT),
  };
}

export function buildTechWorksListFilter(
  farmId: string,
  { panel, period, withoutTechOperation }: ITechWorksFilter
): string {
  const conditions = [buildFilterCondition("farmId", "==", farmId)];

  if (period) {
    conditions.push(
      buildFilterCondition(
        "startedAt",
        "<=",
        endOfDay(parseISO(period.to)).toISOString()
      ),
      buildFilterCondition(
        "finishedAt",
        ">=",
        startOfDay(parseISO(period.from)).toISOString()
      )
    );
  }
  if (panel.farmLandId) {
    conditions.push(buildFilterCondition("farmLandId", "==", panel.farmLandId));
  }
  if (panel.techAssetName) {
    conditions.push(buildFilterCondition("techAssetName", "==", panel.techAssetName));
  }
  if (panel.trailerAssetName) {
    conditions.push(
      buildFilterCondition("trailerAssetName", "==", panel.trailerAssetName)
    );
  }
  if (panel.driverFullName) {
    conditions.push(buildFilterCondition("driverFullName", "==", panel.driverFullName));
  }
  if (panel.areaFrom !== null) {
    conditions.push(buildFilterCondition("areaDoneHa", ">=", panel.areaFrom));
  }
  if (panel.areaTo !== null) {
    conditions.push(buildFilterCondition("areaDoneHa", "<=", panel.areaTo));
  }
  if (withoutTechOperation) {
    conditions.push("techOperationId==null");
  }

  return buildFilterExpression(...conditions);
}
